// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__DH5Uk","load7":"Loader_load7__0Z4DX"};